import React, { useRef, useEffect, useState } from 'react';
import './ServicesSection.css';

const services = [
  { icon: '/images/01-Illustration-Design.jpg' },
  { icon: '/images/02-Video-Production.jpg' },
  { icon: '/images/03-Packaging-Merch-Design.jpg' },
  { icon: '/images/04-Print-Design.jpg' },
  { icon: '/images/05-SocialMediaNCreatives.jpg' },
  { icon: '/images/06-ProfessionalPhotography.jpg' },
  { icon: '/images/07-AdCampaignConcept.jpg' },
];

const coloredTitle = [
  { char: 'A', color: '#ed448d' },
  { char: 'l', color: '#5fc2a2' },
  { char: 'l', color: '#f6953d' },
  { char: ' ', color: '' },
  { char: 'y', color: '#f28aa6' },
  { char: 'o', color: '#f38166' },
  { char: 'u', color: '#6e54a3' },
  { char: 'r', color: '#ed448d' },
  { char: ' ', color: '' },
  { char: 'c', color: '#5fc2a2' },
  { char: 'r', color: '#f6953d' },
  { char: 'e', color: '#f28aa6' },
  { char: 'a', color: '#f38166' },
  { char: 't', color: '#6e54a3' },
  { char: 'i', color: '#ed448d' },
  { char: 'v', color: '#5fc2a2' },
  { char: 'e', color: '#f6953d' },
  { char: ' ', color: '' },
  { char: 'n', color: '#f28aa6' },
  { char: 'e', color: '#f38166' },
  { char: 'e', color: '#6f56a3' },
  { char: 'd', color: '#ed448d' },
  { char: 's', color: '#5fc2a2' },
];

const coloredSubtitle = [
  { char: 'i', color: '#f6953d' },
  { char: 'n', color: '#f28aa6' },
  { char: ' ', color: '' },
  { char: 'o', color: '#f38166' },
  { char: 'n', color: '#6e54a3' },
  { char: 'e', color: '#ed448d' },
  { char: ' ', color: '' },
  { char: 'h', color: '#5fc2a2' },
  { char: 'o', color: '#f6953d' },
  { char: 'l', color: '#f28aa6' },
  { char: 'i', color: '#f38166' },
  { char: 's', color: '#6e54a3' },
  { char: 't', color: '#ed448d' },
  { char: 'i', color: '#5fc2a2' },
  { char: 'c', color: '#f6953d' },
  { char: ' ', color: '' },
  { char: 'a', color: '#f28aa6' },
  { char: 'g', color: '#f38166' },
  { char: 'e', color: '#6f56a3' },
  { char: 'n', color: '#ed448d' },
  { char: 'c', color: '#5fc2a2' },
  { char: 'y', color: '#f6953d' },
  { char: '.', color: '#f28aa6' },
];

function ServicesSection() {
  const carouselRef = useRef(null);
  const [direction, setDirection] = useState(1); // 1 for right, -1 for left

  useEffect(() => {
    const scrollAmount = 320;
    const interval = setInterval(() => {
      if (carouselRef.current) {
        const scrollPos = carouselRef.current.scrollLeft;
        const maxScroll = carouselRef.current.scrollWidth - carouselRef.current.offsetWidth;

        // Change direction when reaching either end
        if (scrollPos >= maxScroll) {
          setDirection(-1);
        } else if (scrollPos <= 0) {
          setDirection(1);
        }

        carouselRef.current.scrollBy({
          left: scrollAmount * direction,
          behavior: 'smooth',
        });
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [direction]);

  const scrollLeft = () => {
    carouselRef.current.scrollBy({ left: -320, behavior: 'smooth' });
  };

  const scrollRight = () => {
    carouselRef.current.scrollBy({ left: 320, behavior: 'smooth' });
  };

  return (
    <section className="services-section">
      <div className="container-padding">
        <div className="services-title-left">
          <p className="services-subtitle">One stop agency</p>
          <h2 className="services-main-title">
            {coloredTitle.map((letter, i) => (
              <span key={i} style={{ color: letter.color }}>{letter.char}</span>
            ))}
            <br />
            {coloredSubtitle.map((letter, i) => (
              <span key={i + 100} style={{ color: letter.color }}>{letter.char}</span>
            ))}
          </h2>
        </div>
        <div className="carousel-controls">
          <button onClick={scrollLeft} className="carousel-btn">‹</button>
          <div className="services-carousel" ref={carouselRef}>
            {services.map((service, index) => (
              <div className="service-tile" key={index}>
                <img src={service.icon} alt={`Service ${index + 1}`} className="service-icon" />
              </div>
            ))}
          </div>
          <button onClick={scrollRight} className="carousel-btn">›</button>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
